import "reflect-metadata";
import {inject, injectable} from "inversify";
import {UserRepository} from "@dropDesk/domain/repositories/user/user.repository";

@injectable()
export class TransferUserUseCase {
  private _repository: UserRepository;

  constructor(@inject(UserRepository) repository: UserRepository) {
    this._repository = repository;
  }

  public call(idNewClient: string, idUser: string): Promise<void> {
    return this._repository.transferUser(idNewClient, idUser);
  }
}

